export const SET_LIST = 'SET_LIST';
export const SET_TOTAL = 'SET_TOTAL';
export const SET_SORT = 'SET_SORT';
export const SET_ORDER = 'SET_ORDER';
export const CLEAR = 'CLEAR';
export const CHANGE_ELEMENT = 'CHANGE_ELEMENT';
export default {
  SET_LIST,
  SET_TOTAL,
  SET_SORT,
  SET_ORDER,
  CLEAR,
  CHANGE_ELEMENT,
};
